import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  type OfferPriceV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceAccessorGetDisplayPrice } from '../../../model/priceAccessor/priceAccessorGetDisplayPrice'
import { productAccessorIsLifestyleProduct } from '../../../model/productAccessor/productAccessorIsLifestyleProduct'
import { useProductPageContext } from '../../productPageContext'

export const ProductBuyBoxPriceLabel: FC = () => {
  const { currentOffer, currentPrescriptionType, product } =
    useProductPageContext()
  const lifeStyleProduct: boolean = productAccessorIsLifestyleProduct(product)
  let productPrescriptionPrice: OfferPriceV1 | null = null

  if (currentOffer) {
    productPrescriptionPrice = priceAccessorGetDisplayPrice(
      currentOffer,
      currentPrescriptionType,
    )
  }

  const isInsuranceOrFreePrescription = [
    PrescriptionPrescriptionTypeEnum.FreePrescription as string,
    PrescriptionPrescriptionTypeEnum.InsurancePrescription as string,
  ].includes(currentPrescriptionType)
  const hasNoFixedPriceDifference =
    !productPrescriptionPrice?.fixedPriceDifference

  const priceLabel =
    isInsuranceOrFreePrescription &&
    hasNoFixedPriceDifference &&
    !lifeStyleProduct ? (
      <FormattedMessage id="productPricing.buyBox.yourAdditionalPayment" />
    ) : (
      <FormattedMessage id="productPricing.buyBox.yourPrice" />
    )

  return <div className="flex items-center justify-start">{priceLabel}</div>
}
